export default __webpack_public_path__ + "static/media/maple.texture.dfe983ac.webp";